import { ControlTranslation } from "AlignComponents";
import classNames from "classnames";
import { Container, Offcanvas } from "react-bootstrap";
import RGL, { WidthProvider } from "react-grid-layout";
import { FaCloudDownloadAlt, FaUserCog } from "react-icons/fa";
import { HiOutlineSave, HiOutlineTrash, HiOutlineViewGridAdd } from "react-icons/hi";
import { MdOutlineClose } from "react-icons/md";

const GridLayout = WidthProvider(RGL);
export const AlignUIRender = ({ dataLoaded, isEmployee, userName, designMode, saveLayout, widgetMenuOpen, widgetsComponents, addWidget, removeWidget, layout, onLayoutChange, closeDesignMode, openWidgetMenu, closeWidgetMenu }: any) => (
  <>
    <Container fluid className={classNames('home', { designMode })}>
      {
        designMode ? (
          <div className="designer-bar">
            Designer Mode
            <div className="designer-button ms-auto" onClick={saveLayout}>
              <HiOutlineSave size="18" />
              Save Layout
            </div>

            <div className="designer-button" onClick={openWidgetMenu}>
              <HiOutlineViewGridAdd size="18" />
              Add Widgets
            </div>

            <div className="designer-button" onClick={closeDesignMode}>
              <MdOutlineClose size="18" />
              Close
            </div>
          </div>
        ) : null
      }

      {
        dataLoaded && !isEmployee ? (
          <GridLayout layout={layout} cols={12} rowHeight={50} onLayoutChange={onLayoutChange} draggableHandle=".drag-handle" isDraggable={designMode} isResizable={designMode}>
            {
              widgetsComponents.filter((w: any) => w.visible).map((w: any) => (
                <div key={w.id}>
                  {
                    designMode ? (
                      <div className="widget-info">
                        <ControlTranslation system={true} controlId={`lbl${w.id}`} />

                        {
                          w.id != "selfservice" ? (
                            <HiOutlineTrash size={14} className="ms-auto" onClick={removeWidget} />
                          ) : null
                        }
                      </div>
                    ) : null
                  }

                  {w.component}
                </div>
              ))
            }

          </GridLayout>
        ) : isEmployee ? (
          <div>
            <div className="text-group">
              <FaUserCog size="40" />
              <h6>
                <ControlTranslation system={true} controlId="lblwelcome" />, {userName}
              </h6>
              <span>
                <ControlTranslation system={true} controlId="lblconsultant" />
              </span>
            </div>
          </div>
        ) : (
          <div>
            <div className="text-group">
              <FaCloudDownloadAlt size="40" />
              <h6>
                <ControlTranslation system={true} controlId="lblloading" />
              </h6>
              <span>
                <ControlTranslation system={true} controlId="lblwait" />
              </span>
            </div>
          </div>
        )
      }


      <Offcanvas show={widgetMenuOpen} onHide={closeWidgetMenu} className="widget-menu" backdropClassName="backdrop" placement="end">
        <Offcanvas.Header className="border-bottom" closeButton>
          <Offcanvas.Title>
            <HiOutlineViewGridAdd size="20" color="#0080FF" className="me-2" />
            <ControlTranslation system={true} controlId="lbladdwidget" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="home-widget">
            {
              widgetsComponents.filter((w: any) => !w.visible).map((w: any, i: any) => (
                <div key={i} className="home-widget-item" onClick={addWidget}>
                  <h6>
                    <ControlTranslation system={true} controlId={`lbl${w.id}`} />
                  </h6>
                  <ControlTranslation system={true} controlId={`lbl${w.id}desc`} />
                </div>
              ))
            }
          </div>
        </Offcanvas.Body>
      </Offcanvas >
    </Container>
  </>
);
